import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = {
  children: ReactNode;
  resetKey?: string | null;
  onReset?: () => void;
};

type State = {
  error: Error | null;
};

/** Keeps Mail chrome alive when a single message body/attachment blows up render. */
export class MailReaderErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Mail reader render failed", error, info.componentStack);
  }

  componentDidUpdate(prev: Props) {
    if (prev.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null });
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div className="mail-reader-error pad" role="alert">
          <p>
            <strong>Could not display this message.</strong>
          </p>
          <p className="muted">{this.state.error.message || "Render error"}</p>
          <button
            type="button"
            className="text-btn"
            onClick={() => {
              this.setState({ error: null });
              this.props.onReset?.();
            }}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
